<template>
  <div
    class="app-main-inner app-main-page-tab"
    type="primary"
  >
    <div style="display: flex;flex:1;height: 100%">
      <cargo-left-right-resize
        :left-style="{'overflow': 'hidden'}"
        :right-style="{flex:'none','max-width':'50%', 'width': '20%'}"
        style="min-height:100%"
      >
        <template slot="left" :style="{minWidth:'190px',border:'1px solid #ccc',height:'100%',width: '80%'}">
          <div style="display: flex;flex-direction: column;height: 100%;overflow-y: auto;">
            <div style="display: flex;flex-direction: column;flex-grow: 1">
              <div>
                <template v-if="!isAllowEdit">
                  <search-item
                    ref="searchItem"
                    config-module="2350"
                    :reset="true"
                    :expand-adv="false"
                    :custom-sim-query-placeholder="$t('CargoMsg.QuickSearchUser')"
                    :col-settings="{style:'width: 516px;'}"
                    @click-more="value=>{isAdvancedQuery=value}"
                    @simSearchItemCallBack="toSimpleQuery"
                    @advSearchItemCallBack="toAdvancedQuery"
                  >
                    <template slot="operations">
                      <el-dropdown
                        v-if="!ojEnable"
                        split-button
                        type="primary"
                        :style="{marginLeft: isAdvancedQuery ? '5px' : '', marginRight: '5px'}"
                        @click="userManagerCommandHandle()"
                        @command="p=>{userManagerCommand=p;userManagerCommandHandle()}"
                      >
                        <span v-if="userManagerCommand !== $t('CargoMsg.Cargo_Import')">{{ userManagerCommand }}</span>
                        <span v-if="userManagerCommand === $t('CargoMsg.Cargo_Import')">{{ $t('CargoMsg.Cargo_Import') }}</span>
                        <el-dropdown-menu slot="dropdown">
                          <!--新增-->
                          <el-dropdown-item :command="$t('CargoMsg.Cargo_Add')">{{ $t('CargoMsg.Cargo_Add') }}</el-dropdown-item>
                          <!--导入-->
                          <el-dropdown-item :command="$t('CargoMsg.Cargo_Import')">{{ $t('CargoMsg.Cargo_Import') }}</el-dropdown-item>
                          <!--下载模板-->
                          <el-dropdown-item :command="$t('CargoMsg.Cargo_DownLoad_Template')">{{ $t('CargoMsg.Cargo_DownLoad_Template') }}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button type="primary" :disabled="!selectedData" @click="toEditUser">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
                      <el-button
                        v-if="!ojEnable"
                        type="danger"
                        :disabled="notAllowEditActive"
                        @click="toEditUserActive"
                      >{{ currentActive ? $t('CargoMsg.Cargo_Invalid2') : $t('CargoMsg.Cargo_Activation') }}</el-button>
                      <el-button type="primary" @click="fetchList">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
                      <el-button :disabled="!selectedRows || selectedRows.length <= 0" type="primary" @click="batchEdit">{{ $t('SeaExport.BatchProcessing') }}</el-button>
                      <el-button type="primary" @click="userSecurityPolicyHandler">{{ $t('CargoMsg.Cargo_UserSecurityPolicy') }}</el-button>
                    </template>
                  </search-item>
                </template>
                <template v-else>
                  <div style="padding-bottom: 10px;margin-top: 5px;">
                    <el-button type="primary" :disabled="btnSaveEnable" @click="toSubmit">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
                    <el-button type="primary" @click="toCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
                    <el-button v-if="oneFormData.uuid" type="primary" @click="toRoleManagment">{{ $t('CargoMsg.Cargo_RoleGroupManagement') }}</el-button>
                  </div>
                </template>
              </div>
              <div class="triggers">
                <el-form :inline="true" label-width="60px" label-position="left">
                  <div class="el-form-item-wrapper">
                    <span style="padding-right: 10px"> {{ $t('CargoMsg.Cargo_RecordCount') + ':' }} {{ rowData.length }}</span>
                  </div>
                </el-form>
              </div>
              <cargo-ag-grid
                config-module="20221129"
                :show-side-bar="false"
                :column-defs="columnDefs"
                :row-data="rowData"
                :grid-options="gridOptions"
                :side-bar="sideBarDefs"
                style="width: 100%; height: 85%"
                @gridReady="params=>{userGridApi=params.api}"
              />
            </div>
            <div class="section " style="width: 100%;padding-top: 15px">
              <el-form
                ref="form"
                label-width="100px"
                style="width: 100%; height: 100%"
                label-position="left"
              >
                <div class="form-row" style="width: 100%; height: 100%">
                  <el-form :label-width="isZh?'100px':'160px'" label-position="left">
                    <el-row :gutter="10">
                      <el-col :span="8">
                        <el-form-item :label="$t('CargoMsg.Cargo_LoginName')" prop="actualAmountNo">
                          <el-input v-model="oneFormData.login" :disabled="true" />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_ChineseNamed')" prop="paymentCompany">
                          <el-input v-model="oneFormData.chineseName" :disabled="oujianEditLimit || (isHM && oneFormData.uuid)" :style="isAllowEdit && isHM && !oneFormData.uuid ?'width:75%':''" />
                          <el-button v-if="isAllowEdit && isHM && !oneFormData.uuid" type="primary" @click="openChooseThirdUser">{{ $t('CargoMsg.Cargo_Select') }}</el-button>
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_email')" prop="companyBank">
                          <el-input
                            v-model="oneFormData.email"
                            :disabled="oujianEditLimit || (isHM && oneFormData.uuid)"
                            @keyup.native="onEmailChange"
                          />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_MobilePhoneNo')">
                          <el-input v-model="oneFormData.cell" :disabled="!isAllowEdit || (isHM && oneFormData.uuid)" />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_PasswordExpirationDate')">
                          <el-date-picker
                            v-model="oneFormData.expirationDate"
                            type="date"
                            :style="{width: '100%'}"
                            :disabled="!isAllowEdit"
                            placeholder=" "
                          />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.CargoMsg_QQ')">
                          <el-input
                            :value="oneFormData.qq"
                            :disabled="!isAllowEdit"
                            @input="onQqInput"
                          />
                        </el-form-item>
                        <el-form-item v-if="ojEnable" :label="$t('CargoMsg.CargoMsg_CorporateName')">
                          <el-input
                            v-model="oneFormData.thirdPartyName"
                            :disabled="oujianEditLimit"
                          />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_RoleGroup')">
                          <el-input v-model="oneFormData.userGroupText" :disabled="true" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item :label="$t('CargoMsg.Cargo_Password')">
                          <el-input
                            :value="oneFormData.password"
                            type="password"
                            :disabled="!isAllowEdit"
                            @input="onPasswordInput"
                          />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_EnglishNamed')">
                          <el-input v-model="oneFormData.englishName" :disabled="!isAllowEdit" />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_Tel')">
                          <el-input v-model="oneFormData.phone" :disabled="!isAllowEdit" />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_Fax')">
                          <el-input v-model="oneFormData.fax" :disabled="!isAllowEdit" />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_Superior')">
                          <cargo-advance-select
                            :select-type="selectTypeNames.basic_data_User"
                            :callback-params="{key:'manager'}"
                            callback-method-type="value"
                            :default-value="oneFormData.manager?oneFormData.manager:''"
                            :method-params="{officeId:oneFormData.defaultOfficeId}"
                            filterable
                            :disabled="!isAllowEdit"
                            @parentCallBack="getValueFromChild"
                          />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_NetworkManagementCode')">
                          <el-input
                            v-model="oneFormData.netCode"
                            :disabled="!isAllowEdit"
                            :maxlength="2"
                            @keyup.native="netCodeChange"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item :label="$t('CargoMsg.Cargo_ElectricitySupplierAccountOrNot')" style="float: left">
                          <el-checkbox v-model="oneFormData.externalUser" :disabled="true" />
                        </el-form-item>
                        <el-form-item v-if="!isPlatformMaintenance" :label="$t('CargoMsg.Cargo_SystemAdministrator')" style="float: left; margin-left: 40px">
                          <el-checkbox v-model="isSystemAdmin" :disabled="!isAllowEdit" />
                        </el-form-item>
                        <el-form-item label-width="0" style="float: left; margin-left: 40px">
                          <span>{{ $t('SystemMaintenance.NonLoginUser') }}</span>
                          <el-tooltip
                            placement="top"
                            :content="$t('SystemMaintenance.ValidUserNotNeedLogin')"
                          >
                            <i class="el-icon-question" style="color:#1989fa;font-size: 16px;" />
                          </el-tooltip>
                          <el-checkbox v-model="oneFormData.isDisableLogin" :disabled="!isAllowEdit" style="margin-left: 10px" />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_TheCompanyToWhichTheAccountBelongs')" style="clear: both">
                          <el-input
                            v-model="oneFormData.partnerUUIDStr"
                            :disabled="true"
                            :maxlength="2"
                            @keyup.native="netCodeChange"
                          />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_UserCompany')">
                          <cargo-advance-select
                            :select-type="selectTypeNames.basic_data_Office"
                            :default-value="oneFormData.defaultOfficeId?oneFormData.defaultOfficeId:''"
                            filterable
                            :placeholder="' '"
                            :disabled="!isAllowEdit"
                            @parentCallBack="officeChange"
                          />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_UserDepartment')">
                          <cargo-department-select
                            :disabled="!isAllowEdit"
                            :callback-params="{key:'defaultDepId'}"
                            :office-id="Number(oneFormData.defaultOfficeId)"
                            :enables="true"
                            :placeholder="' '"
                            :department-id="Number(oneFormData.defaultDepId)"
                            @change="p => {oneFormData.defaultDepId = p.value || 0}"
                          />
                        </el-form-item>
                        <el-form-item :label="$t('CargoMsg.Cargo_UserCode')">
                          <el-input
                            v-model="oneFormData.userCode"
                            :disabled="oujianEditLimit || (isHM && oneFormData.uuid)"
                            :maxlength="32"
                            @keyup.native="userCodeChange"
                          />
                        </el-form-item>
                        <el-form-item v-if="!isPlatformMaintenance" :label="$t('CargoMsg.Cargo_ExternalAssociationCode')">
                          <el-input
                            v-model="oneFormData.externalCode"
                            :disabled="!isAllowEdit"
                            @keyup.native="externalAssociationCodeChange"
                          />
                        </el-form-item>
                        <el-form-item v-if="isPlatformMaintenance" :label="$t('CargoMsg.Cargo_SystemAdministrator')" style="float: left">
                          <el-checkbox v-model="isSystemAdmin" :disabled="!isAllowEdit" />
                        </el-form-item>
                        <el-form-item v-if="isPlatformMaintenance" :label="$t('CargoMsg.Cargo_PlatformCustomerService')" style="float: left; margin-left: 40px">
                          <el-checkbox v-model="oneFormData.isPlatformCustomer" :disabled="!isAllowEdit" @change="handleCheckboxChange" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-form>
            </div>
          </div>
          <el-upload
            v-show="false"
            :action="URL.sys.userImport"
            :data="Object.assign({ activeUserCount }, $store.state.settings.bsLimitInfo)"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-error="handleError"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button ref="uploadBtn" />
          </el-upload>
        </template>
        <template slot="right" style="min-width:190px;width: 20%; border:1px solid #ccc;">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="officeDeptTree.gridOptions"
            :column-defs="officeDeptTree.columnDefs"
            :row-data="officeDeptTree.rowData"
            style="width:100%;height: 100%"
            @gridReady="params=>{gridApi=params.api}"
          />
        </template>
      </cargo-left-right-resize>
    </div>
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :check-content="oneFormData"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
    <user-security-policy-dialog
      :visible.sync="userSecurityPolicyDialog.visible"
    />
    <!-- 批量修改用户弹窗 -->
    <batch-modify-user-dialog
      :visible.sync="batchModifyUserDialog.visible"
      :user="batchModifyUserDialog.user"
      :user-keys="batchModifyUserDialog.userKeys"
      @callback="batchModifyUserCallback"
    />
    <choose-third-User-dialog :visible.sync="chooseUserDialog.visible" @callBack="thirdUserSelected" />
    <!--用户角色组配置-->
    <role-group-dialog :visible.sync="roleGroupDialog.visible" :user-id="roleGroupDialog.userId" :user-groups="selectedData ? selectedData.userGroups : []" :current-roles="selectedData ? selectedData.roles : []" @callback="selectedUserGroups" />
  </div>
</template>

<script>

import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getUserInfo } from '@/utils/auth'
import { getUserUrl, saveUser, editUser, activeUser, getAllUsers, getCargoAllUser } from '@/api/user'
import { getOfficeDeptTree } from '@/api/office'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { validAlphabets, validUserCode } from '@/utils/validate'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import { getFilterCacheList, getObjectByCache, syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import ColumnUtils from '@/utils/ColumnUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { CheckRuleUtil } from '@/class/cargo/model/utils/CheckRuleUtil'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import BatchModifyUserDialog from '@/views/cargo/v0/SystemMaintenance/components/user/BatchModifyUserDialog.vue'
import StrUtils from '@/utils/StrUtils'
import { getUserDepartmentOfficesCache, getUsersByPrivilegeDetailCache } from '@/class/model/sys/User'
import UserSecurityPolicyDialog from '@/views/cargo/v0/SystemMaintenance/components/user/userSecurityPolicyDialog.vue'
import { checkPasswordRuleFunc } from '@/api/userSecurityPolicy'
import ChooseThirdUserDialog from '@/views/cargo/v0/SystemMaintenance/components/user/chooseThirdUserDialog.vue'
import RoleGroupDialog from '@/views/cargo/v0/SystemMaintenance/components/user/roleGroupDialog.vue'

export default {
  name: 'UserManage',
  components: { RoleGroupDialog, UserSecurityPolicyDialog, cargoAdvanceSelect, cargoDepartmentSelect, cargoLeftRightResize, CheckingWindow, searchItem, BatchModifyUserDialog, ChooseThirdUserDialog },
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: null,
      loading: false,
      isAllowEdit: false,
      isAllowEditPassword: false, // 是否允许修改密码（包含和密码输入框配对的前一个输入框）
      isAdvancedQuery: false, // 是否为高级查询
      simpleFilter: {
        keyword: ''
      },
      complexFilter: {
        conditions: []
      },
      selectedRows: [],
      batchModifyUserDialog: {
        visible: false,
        user: null,
        userKeys: []
      },
      userSecurityPolicyDialog: {
        visible: false
      },
      companyMap: {},
      officeDeptTree: {
        columnDefs: null,
        rowData: [],
        gridOptions: {}
      },
      currentUserInfo: {},
      validOptions: [{
        label: this.$t('CargoMsg.Cargo_PleaseSelect'),
        value: ''
      },
      {
        label: this.$t('CargoMsg.Cargo_Valid'),
        value: 1
      }, {
        label: this.$t('CargoMsg.Cargo_Invalid2'),
        value: 0
      }],
      searchConditions: {
        isConsumerUser: true,
        isAdminUser: false,
        active: '',
        likeName: ''
      },
      fromDialog: {
        isShow: false
      },
      oneFormData: {
        uuid: '',
        defaultOfficeId: 0,
        defaultDepId: 0,
        userCode: '',
        chineseName: '',
        login: '',
        netCode: '',
        externalCode: '',
        isPlatformCustomer: false,
        externalUser: false,
        partnerUUID: '',
        partnerUUIDStr: '',
        version: 0,
        qq: '',
        type: 3,
        password: '',
        englishName: '',
        phone: '',
        fax: '',
        active: true,
        manager: 0,
        expirationDate: null,
        email: '',
        cell: '',
        trackingTemplateUuids: '',
        isDisableLogin: true,
        thirdPartyName: '',
        userGroups: [],
        userGroupText: ''
      },
      gridOptions: {
      },
      selectDataRoleMap: null,
      selectedData: null,
      gridParams: {},
      gridApi: null,
      userGridApi: null,
      columnDefs: null,
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      baseRowData: [], // 页面过滤的临时数据
      currentActive: '',
      userManagerCommand: this.$t('CargoMsg.Cargo_Add'),
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      btnSaveEnable: false,
      activeUserCount: 0,
      ojEnable: false,
      isHM: false,
      chooseUserDialog: {
        visible: false
      },
      roleGroupDialog: {
        visible: false,
        userId: 0
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    url() {
      return URL
    },
    filter() {
      return this.isAdvancedQuery ? this.complexFilter : this.simpleFilter
    },
    isSystemAdmin: {
      get() {
        return Number(this.oneFormData.type) === 2 || Number(this.oneFormData.type) === 1
      },
      set(val) {
        this.oneFormData.type = val ? 2 : 3
      }
    },
    notAllowEditActive() {
      return this.currentUserInfo.probation && this.rowData.filter(item => item.active).length >= 10 && !this.currentActive
    },
    // 判断是否是平台维护
    isPlatformMaintenance() {
      return this.$store.getters.tenantId === 1
    },
    // 之前的逻辑是isAllowEdit 所以当开启配置时走!!this.oneFormData.uuid 不然就是走!this.isAllowEdit的判断
    oujianEditLimit() {
      return this.ojEnable ? this.isAllowEdit ? !!this.oneFormData.uuid : true : !this.isAllowEdit
    }
  },
  watch: {
    isAllowEdit(newVal) {
      if (newVal) {
        // 延迟设置允许修改密码的标识
        setTimeout(() => {
          this.isAllowEditPassword = this.isAllowEdit
        }, 1500)
      } else {
        this.isAllowEditPassword = false
      }
    }
  },
  created() {
    // 获取租户信息
    this.gridOptions = {
      rowClassRules: {
        'grid-row-zebra-even': function(params) {
          return !(params.rowIndex % 2)
        },
        'grid-row-zebra-odd': function(params) {
          return (params.rowIndex % 2)
        }
      },
      rowSelection: 'multiple',
      suppressCellSelection: true,
      defaultColDef: {
        resizable: true,
        filter: true
      },
      // 多选（勾选框触发）
      onRowSelected: (event) => {
        if (!event || !event.data) return
        if (event.node.isSelected()) {
          this.selectedRows.push(event.data)
        } else {
          this.selectedRows = this.userGridApi.getSelectedRows()
        }
      },
      onRowClicked: this.onUserRowClick,
      onCellDoubleClicked: this.doubleClickedEditUser
    }
    this.columnDefs = [
      {
        headerName: '', width: 55, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_LoginName'),
        field: 'login',
        width: 240
      }, {
        headerName: this.$t('CargoMsg.Cargo_ChineseName'),
        field: 'chineseName',
        width: 100
      }, {
        headerName: this.$t('CargoMsg.Cargo_EnglishName'),
        field: 'englishName',
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_email'),
        field: 'email',
        width: 240
      }, {
        headerName: this.$t('CargoMsg.Cargo_Tel'),
        field: 'phone',
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_Fax'),
        field: 'fax',
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_ElectricitySupplierAccountOrNot'),
        field: 'externalUser',
        width: 140,
        valueGetter: function(params) {
          if (params.data.externalUser) {
            return '√'
          } else {
            return ''
          }
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_TheCompanyToWhichTheAccountBelongs'),
        field: 'partnerUUIDStr',
        width: 200
      },
      {
        headerName: this.$t('CargoMsg.Cargo_UserCompany'),
        field: 'defaultOfficeId',
        width: 200,
        valueFormatter: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_UserDepartment'),
        field: 'defaultDepId',
        width: 200,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ValidOrNot'),
        field: 'active',
        width: 100,
        valueGetter: (params) => {
          if (params.data.active) {
            return this.$t('SystemMaintenance.Valid')
          } else {
            return this.$t('SystemMaintenance.Invalid')
          }
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_Superior'),
        colId: 'manager',
        field: 'manager',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        },
        width: 150
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ExternalAssociationCode'),
        field: 'externalCode',
        width: 100
      }
    ]
    this.officeDeptTree.columnDefs = [
      {
        headerName: 'Path',
        field: 'path',
        width: 300,
        hide: true
      }
    ]

    this.officeDeptTree.gridOptions = {
      rowSelection: 'multiple',
      groupDefaultExpanded: 0,
      suppressRowClickSelection: true,
      treeData: true,
      getDataPath: (data) => {
        return data.path.split(',')
      },
      autoGroupColumnDef: {
        headerName: this.$t('CargoMsg.Cargo_Name'),
        width: 300,
        tooltipValueGetter: (params) => {
          return ''
        },
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: true,
          innerRenderer: (params) => {
            if (params.data.type === 1) {
              return '[' + params.data.code + ']' + params.data.chineseName
            }
            if (params.data.type === 3) {
              let iconName = ''
              if (this.isAllowEdit) {
                iconName = params.data.checked ? 'checkbox-checked-edit' : 'checkbox-notChecked-edit'
              } else {
                iconName = params.data.checked ? 'checkbox-checked-notEdit' : 'checkbox-notChecked-notEdit'
              }
              return `<svg class="svg-icon" aria-hidden="true" style="height:15px;width:15px;vertical-align:text-bottom;">
              <use xlink:href="#icon-${iconName}"></use></svg>${params.data.chineseName}`
            }
            return params.data.chineseName
          }
        },
        onCellClicked: params => {
          if (this.isAllowEdit) {
            params.data.checked = !params.data.checked
            params.api.refreshCells({ force: true })
          }
        }
      },
      onRowDataChanged: event => {
        /* 清除单选行 */
        this.selectedNode = null
        event.api.clearFocusedCell()
        // 重置（多选）选中行
        this.selectedRows = []
        if (this.rowData.length > 0) {
          setTimeout(() => {
            const nodes = this.gridApi.rowModel.rootNode.allLeafChildren
            for (const p of nodes) {
              if (p.data.checked) {
                this.expandedNode(p)
              }
            }
            this.gridApi.onGroupExpandedOrCollapsed()
          }, 100)
        }
      },
      getRowClass: (params) => {
        if (!params.node.group && params.data.isMaster) {
          return 'is-master'
        }
      },
      onRowClicked: this.onTreeRowClick
    }

    // CARGO-45569 用户数据CargoWare读取欧坚数据库
    this.ojEnable = (Number(cache.config.get('oujianPartner')) === 1)
    this.isHM = cache.config.get('ToExoSystem') === 'HONGMING'
  },
  beforeMount() {
    this.setCompanyList()
    this.fetchList()
  },
  mounted() {
    this.currentUserInfo = getUserInfo()
    this.fetchOfficeDeptTree()
  },
  methods: {
    toSimpleQuery(keyword) {
      if (StrUtils.isEmpty(keyword)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterNameEtc'))
        return
      }
      this.filter.keyword = keyword
      this.fetchList(false)
    },
    toAdvancedQuery(data) {
      const filter = this.filter
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        filter.conditions = data
      }
      this.fetchList(false)
    },
    // 平台维护的checkbox的切换方法
    handleCheckboxChange() {
      if (this.oneFormData.isPlatformCustomer) {
        this.isSystemAdmin = true
      }
    },
    expandedNode(expandedNode) {
      if (expandedNode) {
        expandedNode.expanded = true
        if (expandedNode.parent) {
          this.expandedNode(expandedNode.parent)
        }
      }
    },
    fetchOfficeDeptTree() {
      this.loading = true
      getOfficeDeptTree().then(res => {
        this.officeDeptTree.rowData = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    async onUserRowClick(event) {
      if (!event || !event.data) return
      const node = event.data
      if (node.uuid) {
        // 重复点击同一条数据 无需处理
        if (this.selectedData && this.selectedData.uuid === node.uuid) {
          return
        }
        this.selectedData = null
        this.isAllowEdit = false
        this.lookData(node)
      }
    },
    setCompanyList() {
      this.companyMap = new Map()
      const companies = getFilterCacheList(basicCacheKeys.basic_data_Company)
      for (const item of companies) {
        this.companyMap.set(item.uuid, item.chineseName)
      }
    },
    async toLookUser(userId) {
      this.fullscreenLoading = getLoading()
      // 查询用户角色信息
      await getUserUrl(userId).then(res => {
        this.lookData(res.data)
      }).finally((e) => {
        this.fullscreenLoading.close()
      })
    },
    lookData(data) {
      const roleMap = new Map()
      this.selectedData = data
      this.currentActive = data.active
      if (data.roles) {
        for (const item of data.roles) {
          roleMap.set(item.uuid, true)
        }
        this.selectDataRoleMap = roleMap
      } else {
        this.selectDataRoleMap = null
      }
      if (data.partnerUUID) {
        data.partnerUUIDStr = this.companyMap.get(data.partnerUUID)
      }
      if (data.userGroups) {
        data.userGroupText = data.userGroups.map(item => item.groupName).join(',')
      }
      this.oneFormData = { ...data }
      for (const item of this.officeDeptTree.rowData) {
        item.checked = false
        if (this.selectDataRoleMap) {
          if (item.type === 3 && this.selectDataRoleMap && this.selectDataRoleMap.get(item.uuid)) {
            item.checked = true
          }
        }
      }
      this.officeDeptTree.rowData = [...this.officeDeptTree.rowData]
      this.userGridApi.deselectAll()
    },
    clearOfficeDeptTree() {
      if (this.officeDeptTree.rowData) {
        for (const item of this.officeDeptTree.rowData) {
          item.checked = false
        }
        this.officeDeptTree.rowData = [...this.officeDeptTree.rowData]
      }
    },
    onTreeRowClick(event) {
    },
    batchEdit() {
      const rows = this.selectedRows
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.batchModifyUserDialog.user = rows[0]
      this.batchModifyUserDialog.userKeys = rows.map(row => row.uuid)
      this.batchModifyUserDialog.visible = true
    },
    userSecurityPolicyHandler() {
      this.userSecurityPolicyDialog.visible = true
    },
    batchModifyUserCallback() {
      this.fetchList()
    },
    async fetchList(refresh = true, specifyData = null) {
      this.fullscreenLoading = getLoading()
      if (!refresh) {
        const userList = []
        for (const item of this.baseRowData) {
          this.setUserListData(userList, item)
        }
        this.rowData = [...userList]
        this.selectedData = null
        this.clearOfficeDeptTree()
        this.gridOptions.api.clearFocusedCell()
        this.fullscreenLoading.close()
      } else {
        this.filter.conditions = []
        this.filter.keyword = ''
        getAllUsers().then(res => {
          console.log(res.data)
          const userList = []
          res.data.forEach(item => {
            this.setUserListData(userList, item)
          })
          this.rowData = [...userList]
          this.baseRowData = [...res.data]
          this.selectedData = null
          this.clearOfficeDeptTree()
          // 根据传入uuid 展示数据
          if (specifyData) {
            const data = this.rowData.find(p => p.uuid === specifyData)
            if (data) {
              this.lookData(data)
            }
          } else {
            this.gridOptions.api.clearFocusedCell()
          }
          this.fullscreenLoading.close()
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      }
    },
    setUserListData(userList, item) {
      if (item.partnerUUID) {
        item.partnerUUIDStr = this.companyMap.get(item.partnerUUID)
      }
      let check = true
      if (this.isAdvancedQuery) {
        // 邮箱
        check = check && this.matchCondition('user.email', item.email)
        // 登录名
        check = check && this.matchCondition('user.login', item.login)
        // 中文名
        check = check && this.matchCondition('user.chineseName', item.chineseName)
        // 手机
        check = check && this.matchCondition('user.cell', item.cell)
        // qq
        check = check && this.matchCondition('user.qq', item.qq)
        // 英文名
        check = check && this.matchCondition('user.englishName', item.englishName)
        // 电话
        check = check && this.matchCondition('user.phone', item.phone)
        // 上级主管
        check = check && this.matchCondition('user.manager', item.manager)
        // 网管代码
        check = check && this.matchCondition('user.netCode', item.netCode)
        // 默认分公司
        check = check && this.matchCondition('user.defaultOfficeId', item.defaultOfficeId)
        // 是否电商客户
        check = check && this.matchCondition('user.externalUser', item.externalUser)
        // 是否激活
        check = check && this.matchCondition('user.active', item.active)
        // 是否系统管理员
        check = check && this.matchCondition('user.admin', item.type)
      } else {
        const likeName = this.filter.keyword.trim().toLowerCase()
        if (likeName) {
          const login = item.login.toLowerCase()
          const chineseName = item.chineseName.toLowerCase()
          const englishName = item.englishName.toLowerCase()
          const email = item.email.toLowerCase()
          if ((login.indexOf(likeName) === -1) && (chineseName.indexOf(likeName) === -1) &&
            (englishName.indexOf(likeName) === -1) && (email.indexOf(likeName) === -1)) {
            check = false
          }
        }
      }

      if (check) {
        userList.push(item)
      }
    },
    matchCondition(field, value) {
      if (value === null || value === undefined) {
        return false
      }
      let check = true
      const conditions = this.filter.conditions
      if (AdvancedSearchOption.hasField(field, conditions)) {
        const option = AdvancedSearchOption.getOption(field, conditions)
        const operator = option.operator
        const optionValue = option.value
        // 系统管理员特殊处理
        if (field === 'user.admin') {
          const ifAdmin = value.toString() === '2' || value.toString() === '1'
          return (optionValue && ifAdmin) || (!optionValue && !ifAdmin)
        }
        if (operator === '=' && optionValue.toString() !== value.toString()) {
          check = false
        }
        if (operator === 'LIKE' && (value.toString().toLowerCase().indexOf(optionValue.toString().toLowerCase()) === -1)) {
          check = false
        }
        if (operator === 'BATCH' && !optionValue.map(String).includes(value.toString())) {
          check = false
        }
      }
      return check
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.uuid) {
        this.selectedData = node
      }
    },
    clearForm() {
      this.oneFormData = PriceUtils.resetFilter(this.oneFormData)
      this.oneFormData.isDisableLogin = false
    },
    toAddUser() {
      this.clearForm()
      this.gridOptions.api.deselectAll()
      for (const item of this.officeDeptTree.rowData) {
        if (item.type === 3) {
          item.checked = false
        }
      }
      this.officeDeptTree.rowData = [...this.officeDeptTree.rowData]
      this.isAllowEdit = true
    },
    async checkAvailableUserCount() {
      const { userCountLimited, initUserCount, validUserCount } = this.$store.state.settings.bsLimitInfo
      if (userCountLimited && validUserCount >= 0) {
        await this.getActiveUserCount()
        if (this.activeUserCount >= initUserCount + validUserCount) {
          this.$confirm(this.$t('SystemMaintenance.AvailableUserOverMaxLimit'), this.$t('SystemMaintenance.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            type: 'warning'
          }).catch(() => {})
          return false
        }
      }
      return true
    },
    async doubleClickedEditUser(event) {
      const rows = this.selectedData
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.externalUser) {
        this.$message.warning(this.$t('Message.ExternalUsersCannotEdit'))
        return
      }
      await this.toLookUser(event.data.userId)
      this.isAllowEdit = true
    },
    async toEditUser() {
      const rows = this.selectedData
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.externalUser) {
        this.$message.warning(this.$t('Message.ExternalUsersCannotEdit'))
        return
      }
      for (const item of this.officeDeptTree.rowData) {
        if (item.type === 3 && this.selectDataRoleMap && this.selectDataRoleMap.get(item.uuid)) {
          item.checked = true
        } else {
          item.checked = false
        }
      }
      this.officeDeptTree.rowData = [...this.officeDeptTree.rowData]
      this.isAllowEdit = true
    },
    async toEditUserActive() {
      if (!this.selectedData || !this.selectedData.uuid) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // 调用用户状态激活api
      const params = { ...this.selectedData }
      if (params.active) {
        this.$confirm(this.$t('SystemMaintenance.AfterBeAbleToContinue'), this.$t('SystemMaintenance.Confirm'), {
          confirmButtonText: this.$t('SystemMaintenance.Confirm'),
          cancelButtonText: this.$t('SystemMaintenance.Cancel'),
          type: 'warning'
        }).then(() => {
          this.doUpdateActive(params)
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      } else {
        if (!params.isDisableLogin && !await this.checkAvailableUserCount()) {
          return
        }
        this.doUpdateActive(params)
      }
    },
    doUpdateActive(params) {
      this.fullscreenLoading = getLoading()
      activeUser({ active: params.active ? 0 : 1, userIds: `${params.userId}` }).then(() => {
        this.currentActive = !params.active
        this.$message.success(`用户${params.active ? this.$t('CargoMsg.Cargo_Invalid2') : this.$t('CargoMsg.Cargo_Activation')}成功！`)
        const userData = this.rowData.find(row => { return row.userId === params.userId })
        if (userData) {
          userData.active = !params.active
        }
        const baseRowData = this.baseRowData.find(row => { return row.userId === params.userId })
        if (baseRowData) {
          baseRowData.active = !params.active
        }
        syncSpecificBasicData(basicCacheKeys.basic_data_User)
        this.fetchList()
      })
    },
    async toCheckForm() {
      // 校验表单值
      if (!this.oneFormData.email) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseEnterEmail'))
        return false
      }
      if (!await this.check()) {
        return false
      }
      return true
    },
    async check() {
      const oldData = this.rowData.find(p => p.uuid === this.oneFormData.uuid)
      if (oldData && oldData.password === this.oneFormData.password) {
        return true
      }
      // 新增的时候type是0
      if (!this.oneFormData.type) {
        if (this.isSystemAdmin) {
          this.oneFormData.type = 2
        } else {
          this.oneFormData.type = 3
        }
      }
      const data = {
        type: this.oneFormData.type,
        userId: this.oneFormData.userId,
        password: this.oneFormData.password
      }
      const res = await checkPasswordRuleFunc(data)
      if (res.data) {
        const upVo = res.data
        if (!upVo.result) {
          let d = this.$t('CargoMsg.Cargo_PasswordRulePrompt', [upVo.minPasswordLength, upVo.maxPasswordLength])
          if (upVo.requireSpecialChar) {
            d += ',' + this.$t('CargoMsg.Cargo_MustIncludeSpecialChars')
          }
          if (upVo.passwordRepeatCheck) {
            d += ',' + this.$t('CargoMsg.Cargo_NoRepeatLastNPasswords', [upVo.passwordRepeatCheck])
          }
          this.$message.warning(d)
          return false
        }
      } else {
        if (!this.checkPassword(this.oneFormData)) {
          this.$message.warning(this.$t('myResources.password_notCompliant'))
          return false
        }
      }
      return true
    },
    async toSubmit() {
      if (!this.oneFormData.isDisableLogin) {
        const oldData = this.rowData.find(p => p.uuid === this.oneFormData.uuid)
        if (!oldData || oldData.isDisableLogin) {
          const { userCountLimited, initUserCount, validUserCount } = this.$store.state.settings.bsLimitInfo
          if (userCountLimited && validUserCount >= 0) {
            await this.getActiveUserCount()
            const activeUserCount = this.activeUserCount
            if (activeUserCount >= initUserCount + validUserCount) {
              this.$confirm(this.$t('SystemMaintenance.AvailableUserOverMaxLimit'), this.$t('SystemMaintenance.Prompt'), {
                confirmButtonText: this.$t('common.btn.ok'),
                showCancelButton: false,
                type: 'warning'
              }).catch(() => {})
              return
            }
          }
        }
      }
      this.btnSaveEnable = true
      if (!await this.toCheckForm()) {
        this.btnSaveEnable = false
        return
      }
      // CARGO-31252 用户管理中，可以设置字段保存验证规则不为空
      // 判断是否开启验证规则
      const needCheckRule = await CheckRuleUtil.needCheckRule(CheckRuleConstants.NODE_SAVE_USER.code, null, 'useCheckRule')
      if (needCheckRule) {
        this.checkingWindow.checkNode = CheckRuleConstants.NODE_SAVE_USER.code
        this.checkingWindow.callBack = this.realSubmit
        if (!this.oneFormData.roles || this.oneFormData.roles === '') {
          this.oneFormData.roles = []
        }
        if (!this.oneFormData.userGroups || this.oneFormData.userGroups === '') {
          this.oneFormData.userGroups = []
        }
        this.checkingWindow.visible = true
      } else {
        await this.realSubmit()
      }
    },
    async realSubmit() {
      const formData = this.oneFormData
      formData.roles = this.officeDeptTree.rowData.filter(p => p.checked && p.typeDesc === 'role')
      if (!formData.roles || formData.roles === '') {
        formData.roles = []
      }
      if (!formData.userGroups || formData.userGroups === '') {
        formData.userGroups = []
      }
      for (const userGroup of formData.userGroups) {
        if (userGroup.userGroupRoles) {
          for (const role of userGroup.userGroupRoles) {
            role.users = []
          }
        }
      }
      if (!this.oneFormData.uuid) { // 新增时，默认有效
        formData.active = true
      }
      let allowSave = true
      if (formData.active && (!formData.roles || formData.roles.length === 0)) {
        await this.$confirm(this.$t('CargoMsg.Cargo_UserNoRole'), this.$t('CargoMsg.Cargo_ConfirmR'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_ConfirmR'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          allowSave = true
        }).catch(() => {
          allowSave = false
        })
      }
      if (!allowSave) {
        this.btnSaveEnable = false
        return
      }
      formData.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      if (this.oneFormData.uuid) {
        editUser(formData).then(res => {
          if (res.data === 'ok') {
            // 查询用户角色信息
            const roleMap = new Map()
            if (formData.roles) {
              for (const item of formData.roles) {
                roleMap.set(item.uuid, true)
              }
              this.selectDataRoleMap = roleMap
            }
            this.officeDeptTree.rowData = [...this.officeDeptTree.rowData]
            this.isAllowEdit = false
            this.selectedData = null
            this.fetchList(true, this.oneFormData.uuid)
            this.$message.success(this.$t('SystemMaintenance.EditSuccess'))
            /* 更新缓存中的用户信息 */
            const user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', formData.userId)
            if (user) {
              Object.assign(user, formData)
            }
            getUserDepartmentOfficesCache.clear()
            getUsersByPrivilegeDetailCache.clear()
          } else if (res.data === 'emailRepeat') {
            this.$message.warning(this.$t('SystemMaintenance.EmailDuplicate'))
          } else {
            this.$message.warning(res.data)
          }
        }).finally((e) => {
          this.fullscreenLoading.close()
          this.btnSaveEnable = false
        })
      } else {
        saveUser(formData).then(res => {
          if (res.data.message !== 'ok') {
            this.$message.warning(res.data.message)
          } else {
            this.isAllowEdit = false
            this.rowData.push(res.data.user)
            this.baseRowData.push(res.data.user)
            this.oneFormData = { ...res.data.user }
            this.gridOptions.api.clearFocusedCell()
            this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
            getUserDepartmentOfficesCache.clear()
            getUsersByPrivilegeDetailCache.clear()
          }
        }).finally((e) => {
          this.fullscreenLoading.close()
          this.btnSaveEnable = false
        })
      }
    },
    toCancel() {
      this.isAllowEdit = false
      this.selectedData = null
      this.clearOfficeDeptTree()
      this.gridOptions.api.clearFocusedCell()
    },
    netCodeChange() {
      if (this.oneFormData.netCode && validAlphabets(this.oneFormData.netCode)) {
        this.oneFormData.netCode = this.oneFormData.netCode.toUpperCase()
      } else {
        this.oneFormData.netCode = ''
      }
    },
    externalAssociationCodeChange() {
      // 只保存数字或者字母
      if (this.oneFormData.externalCode && !validUserCode(this.oneFormData.externalCode)) {
        this.oneFormData.externalCode = ''
        this.$message.warning(String(this.$t('CargoMsg.Cargo_ExternalAssociationCodeValidMessage')))
      }
    },
    userCodeChange() {
      if (this.oneFormData.userCode && !validUserCode(this.oneFormData.userCode)) {
        this.oneFormData.userCode = ''
        this.$message.warning(this.$t('SystemMaintenance.UserAllowsInputLettersNumbers'))
      }
    },
    onEmailChange() {
      if (this.oneFormData.email) {
        this.oneFormData.login = this.oneFormData.email
      }
    },
    getValueFromChild(obj) {
      this.oneFormData[obj.key] = obj.value || 0
    },
    // 新增、导入、下载模板
    async userManagerCommandHandle() {
      switch (this.userManagerCommand) {
        case this.$t('CargoMsg.Cargo_Add'):
          this.toAddUser()
          break
        case this.$t('CargoMsg.Cargo_Import'):
          await this.getActiveUserCount()
          this.$refs.uploadBtn.$el.click()
          break
        case this.$t('CargoMsg.Cargo_DownLoad_Template'):
          ExportUtils.downloadTemplateFile('ImportUserTemplate.xls', 'userManager')
          break
      }
    },
    beforeUpload(file) {
      this.loading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.loading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.loading.close()
    },
    // 上传成功
    async uploadSuccess(res, file, fileList) {
      if (this.loading) this.loading.close()
      // 如果上传成功
      if (res.ok) {
        await this.fetchList()
        const { data } = res
        let msg = data.message
        if (data.loginCount > 0) {
          const { userCountLimited, initUserCount, validUserCount } = this.$store.state.settings.bsLimitInfo
          if (userCountLimited && validUserCount >= 0) {
            await this.getActiveUserCount()
            if (this.activeUserCount + data.loginCount >= initUserCount + validUserCount) {
              msg += '<br>' + this.$t('SystemMaintenance.AvailableUserOverMaxLimit')
            }
          }
        }
        this.$confirm(msg, this.$t('SeaExport.ImportComplete'), {
          cancelButtonText: this.$t('Partners.downloadImportResults'),
          confirmButtonText: this.$t('Message.Confirm'),
          distinguishCancelAndClose: true,
          dangerouslyUseHTMLString: true,
          beforeClose: async(action, instance, done) => {
            if (action === 'cancel') {
              await cache.load(cacheName.USER, cacheName.CONFIG)
              // const storageUrl = cache.config.get('StorageURL')
              const url = `${URL.common.findByFileId}/${data.data}?sessionId=${this.$store.getters.token}`
              const el = document.createElement('a')
              document.body.appendChild(el)
              el.href = url
              el.target = '_blank'
              el.click()
              document.body.removeChild(el)
            } else {
              done()
            }
          }
        })
      } else {
        this.$message.error(res.message)
      }
      this.$emit('reload')
    },
    onQqInput(val) {
      if (this.isAllowEditPassword) {
        this.oneFormData.qq = val
      }
    },
    onPasswordInput(val) {
      if (this.isAllowEditPassword) {
        this.oneFormData.password = val
      }
    },
    checkPassword(data) {
      const oldData = this.rowData.find(p => p.uuid === data.uuid)
      if (oldData) {
        if (oldData.password === data.password) {
          return true
        }
      }
      const password = data.password
      if (!password) return false
      // 检查长度是否在8-20之间
      if (password.length < 8 || password.length > 20) return false
      // 检查是否包含数字
      if (!/\d/.test(password)) return false
      // 检查是否包含小写字母
      if (!/[a-z]/.test(password)) return false
      // 检查是否包含大写字母
      if (!/[A-Z]/.test(password)) return false
      return true
    },
    async getActiveUserCount() {
      this.activeUserCount = 0
      const userList = await getCargoAllUser().then(res => res.data)
      if (userList && userList.length > 0) {
        for (const p of userList) {
          if (p.active && !p.isDisableLogin) {
            this.activeUserCount = this.activeUserCount + 1
          }
        }
      }
    },
    officeChange(data) {
      if (data.value && data.value > 0) {
        this.oneFormData.defaultOfficeId = data.value
        // 部门和操作分公司不匹配，则清空部门
        if (this.oneFormData.defaultDepId > 0) {
          const office = getObjectByCache(basicCacheKeys.basic_data_Office_All, 'officeId', this.oneFormData.defaultOfficeId)
          const department = getObjectByCache(basicCacheKeys.basic_data_Department_All, 'departmentId', this.oneFormData.defaultDepId)
          if (office && department && department.officeUuid !== office.uuid) {
            this.oneFormData.defaultDepId = 0
          }
        }
      } else { // 分公司没有数据的时候，需要把部门清空掉
        this.oneFormData.defaultOfficeId = 0
        this.oneFormData.defaultDepId = 0
      }
    },
    openChooseThirdUser() {
      this.chooseUserDialog.visible = true
    },
    thirdUserSelected(data) {
      if (data) {
        this.oneFormData.email = data.email
        this.onEmailChange()
        this.oneFormData.chineseName = data.empName
        this.oneFormData.cell = data.empMobileNumber
        this.oneFormData.userCode = data.empSysId
        this.userCodeChange()
      }
    },
    toRoleManagment() {
      const row = this.selectedData
      if (row.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.roleGroupDialog.userId = row.userId
      this.roleGroupDialog.visible = true
    },
    selectedUserGroups(data) {
      this.oneFormData.userGroups = data
    }
  }
}
</script>

<style scoped lang="scss">
.not-click {
  pointer-events: none;
}
.ccc app-main-inner-row {
  padding: 8px 16px 0 0px;
}
.app-main-inner::v-deep {
  .cargo-advance-search-header > div.cargo-button-group-slider {
    margin-left: 5px;
  }
}
</style>
